import { BASE_URL } from "./baseURL";

const PYQ_FORMATS = ["main", "adv", "neet"];

/** Normalize API icon paths to absolute URLs for <img src>. */
export function resolveMediaUrl(icon) {
  if (!icon || typeof icon !== "string") return "";
  const trimmed = icon.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith("//")) return `https:${trimmed}`;
  if (trimmed.startsWith("/")) return `${BASE_URL}${trimmed}`;
  return `${BASE_URL}/${trimmed}`;
}

/** Resolve PYQ format (main | adv | neet) from a display name, or null for other sections. */
export function resolvePyqFormatFromName(name = "") {
  const lower = String(name).toLowerCase();
  if (lower.includes("neet")) return "neet";
  if (lower.includes("advance") || lower.includes("advanced")) return "adv";
  if (lower.includes("mains")) return "main";
  if (
    lower.includes("jee main") ||
    lower.includes("(jee main)") ||
    (lower.includes("jee") && lower.includes("main"))
  ) {
    return "main";
  }
  return null;
}

export function shouldSendFormatParam(format) {
  return PYQ_FORMATS.includes(format);
}

/** Format for practice_testlist / pyqyearlist / topic-wise sets when applicable; otherwise undefined. */
export function getFormatForApi({ format, paperName, selectedType } = {}) {
  const explicit = format || selectedType;
  if (shouldSendFormatParam(explicit)) return explicit;
  return resolvePyqFormatFromName(paperName) || undefined;
}
